/**
 * Muhit o'zgaruvchilari.
 *
 * `import.meta.env` ning indeks tipi `any` — uni to'g'ridan-to'g'ri
 * ishlatish `no-explicit-any` ni buzadi va xato yozilgan nom jimgina
 * `undefined` bo'lib qoladi. Shuning uchun bitta joyda o'qiladi.
 */
const env = import.meta.env as Record<string, string | undefined>;

/** Bo'sh string ham yo'q hisoblanadi — `?? ''` tuzoqqa tushirmasin. */
function read(name: string, fallback: string): string {
  const value = env[name];
  return value === undefined || value.trim() === '' ? fallback : value;
}

export const API_BASE_URL = read('VITE_API_BASE_URL', 'http://localhost:3010');
